import useTranslation from 'next-translate/useTranslation'

import Icon from '@/atoms/Icon'
import Link from '@/atoms/Link'
import SOCIAL_MEDIA from '@/organisms/Footer/data/socialMedia'

function FooterMiddleSection() {
  const { t } = useTranslation('global')

  return (
    <div className="flex items-center mt-12 ml-8 lg:flex-col lg:ml-0">
      <p>{t('follow_us')}</p>
      <div className="flex">
        {SOCIAL_MEDIA.map(({ name, url }) => (
          <div key={name}>
            <Link href={url} target="_blank">
              <Icon
                className="w-8 h-8 p-2 text-white transition-colors rounded-md hover:bg-sbtviolet-200/100"
                name={name}
              />
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

export default FooterMiddleSection
